import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { BehaviorSubject, Observable, catchError, map, skip, take } from 'rxjs';

import { ConfigurationService, IClientAppConfig } from '@sondermind/configuration';
import { BaseHTTPService, HandleErrorOptions } from '@sondermind/http';
import { HTTP_ERROR_HANDLER, IHttpErrorHandler } from '@sondermind/utilities/models-http';

import { Attestation } from '../models/attestation.interface';

@Injectable({
  providedIn: 'root'
})
export class AttestationDataService extends BaseHTTPService {
  constructor(
    private configurationService: ConfigurationService<IClientAppConfig>,
    private http: HttpClient,
    @Optional()
    @Inject(HTTP_ERROR_HANDLER)
    httpErr: IHttpErrorHandler[],
  ) {
    super(httpErr);
  }

  private store = new BehaviorSubject<Attestation[]>([]);
  store$ = this.store.asObservable();

  refresh(): Observable<Attestation[]> {
    this.fetch().subscribe((as) => this.store.next(as));
    return this.store$.pipe(skip(1), take(1));
  }

  fetch(opts: Partial<HandleErrorOptions> = {}): Observable<Attestation[]> {
    const url = `${this.configurationService.env.apiBase}/v2/attestations`;
    return this.http
      .get<{ attestations: Attestation[]; }>(url)
      .pipe(
        map((p) => p.attestations),
        catchError<Attestation[], Observable<Attestation[]>>(this.handleError.bind(this, opts)),
      );
  }

  markAgreed(
    id: number | string,
    accountSetupContext: string = null,
    opts: Partial<HandleErrorOptions> = {}
  ): Observable<void> {
    const url = `${this.configurationService.env.apiBase}/v2/attestations/${id}`;
    const body = { attestation: { agreed: true }, account_setup_context: accountSetupContext };

    return this.http
      .patch(url, body)
      .pipe(
        map(() => undefined),
        catchError<undefined, Observable<undefined>>(this.handleError.bind(this, opts))
      );
  }
}
